import React from 'react'
import Puck from './Puck';
import { Vector2 } from 'three'

export default function Pucks(props) {
    
    const config = [
        {
            value: 10,
            count: 20,
            color: 0xa03aff
        }, {
            value: 20,
            count: 10,
            color: 0xff10ee
        }, {
            value: 50,
            count: 8,
            color: 0x033aff
        }, {
            value: 100,
            count: 3,
            color: 0x10a0ff
        }, {
            value: -10,
            count: 3,
            color: 0xaaaaaa
        }
    ]
    const getRandomPositionOnRing = (innerRadius, outerRadius) => {
        const c = new Vector2();
        let v = new Vector2(innerRadius + Math.random() * (outerRadius - innerRadius), 0);
        v.rotateAround(c, Math.random() * 2 * Math.PI)
        v.clampLength(innerRadius, outerRadius)
        return { x: v.x, y: v.y }
    }

    let collection = [];
    config.forEach((el, idx) => {
        for (let i = 0; i < el.count; i++) {
            const p = getRandomPositionOnRing(0.4, 0.6);
            collection.push(
                <Puck key={collection.length} position={[p.x, 1.7, p.y]} value={el.value} color={el.color} />
            )
        }
    });

    return (collection);
}